/* tslint:disable */
/* eslint-disable */
export enum WorkEventInvitationExamResultEnum {
  Bestanden = 'BESTANDEN',
  NichtBestanden = 'NICHT_BESTANDEN'
}
